<script>
export default {
  data() {
    return {
      isPasswordVisible: false,
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
};
</script>
<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="row">
          <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
            <h5>Connected Apps</h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-5">
            <div class="card connected-apps">
              <div class="card-body">
                <div class="d-flex app-body-content">
                  <div class="me-2">
                    <span class="rounded-circle"
                      ><img
                        src="@/assets/img/icons/google-icon.svg"
                        alt="img"
                        class="img-fluid avatar-md"
                    /></span>
                  </div>
                  <div>
                    <h6 class="fs-16 mb-1">Google Calendar</h6>
                    <p class="fs-14">
                      Simplifies scheduling and keeps track of your events and
                      appointments.
                    </p>
                  </div>
                </div>
                <div class="app-footer-content">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="d-flex align-items-center justify-content-start">
                        <span class="badge badge-soft-success">Connect</span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div
                        class="d-flex align-items-center justify-content-end form-check form-switch"
                      >
                        <input
                          type="checkbox"
                          id="status-2"
                          class="form-check-input"
                          checked
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
    <!-- Delete Account -->
    <div class="modal fade custom-modal" id="del-account">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div
            class="modal-header d-flex align-items-center justify-content-between border-bottom"
          >
            <h5 class="modal-title">Delete Account</h5>
            <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
              ><i class="ti ti-circle-x-filled fs-20"></i
            ></a>
          </div>
          <form action="#">
            <div class="modal-body">
              <p class="mb-3">
                Are you sure you want to delete This Account? To delete your account, Type
                your password.
              </p>
              <div class="mb-0">
                <label class="form-label">Password</label>
                <div class="pass-group">
                  <input
                    :type="isPasswordVisible ? 'text' : 'password'"
                    class="form-control pass-input"
                    placeholder="*************"
                  />
                  <span
                    @click="togglePasswordVisibility"
                    :class="
                      isPasswordVisible
                        ? 'toggle-password feather-eye'
                        : 'toggle-password feather-eye-off'
                    "
                  ></span>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <a
                href="javascript:void(0);"
                class="btn btn-light me-2"
                data-bs-dismiss="modal"
                >Cancel</a
              >
              <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">Delete Account</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- /Delete Account -->
  </div>
</template>
